import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';

const GalleryPage = () => {
  const { t } = useLanguage();

  const categories = [
    {
      key: 'exteriors',
      images: [
        'https://customer-assets-rejwkqb3.emergentagent.net/job_adriatic-escape-3/artifacts/50mimm7i_IMG_20200725_121228.webp',
        'https://customer-assets-rejwkqb3.emergentagent.net/job_adriatic-escape-3/artifacts/vdr504x8_WhatsApp%20Image%202026-07-21%20at%2012.09.23.jpeg',
        'https://customer-assets-rejwkqb3.emergentagent.net/job_adriatic-escape-3/artifacts/mn8pj4ar_Bozza%202_6%20-%20Photo.jpg'
      ]
    },
    {
      key: 'interiors',
      images: [
        'https://images.unsplash.com/photo-1757924461488-ef9ad0670978?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBhcGFydG1lbnQlMjBpbnRlcmlvciUyMGVsZWdhbnR8ZW58MHx8fHwxNzg0NjI1NDg0fDA&ixlib=rb-4.1.0&q=85',
        'https://images.pexels.com/photos/36708054/pexels-photo-36708054.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
        'https://images.pexels.com/photos/5877250/pexels-photo-5877250.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
      ]
    }
  ];

  return (
    <div data-testid="gallery-page" className="min-h-screen pt-20 bg-white">
      <section className="bg-[#F9F6F0] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-[#D4AF37] text-xs tracking-[0.2em] uppercase mb-2">{t('gallery.overline')}</p>
          <h1 data-testid="gallery-title" className="text-4xl sm:text-5xl lg:text-6xl font-serif tracking-tight text-[#1A1A1A] mb-4">
            {t('gallery.title')}
          </h1>
          <p className="text-base text-[#666666] max-w-2xl mx-auto leading-relaxed">{t('gallery.subtitle')}</p>
        </div>
      </section>

      {categories.map((category, catIndex) => (
        <section key={category.key} className={`py-16 ${catIndex % 2 === 0 ? 'bg-white' : 'bg-[#F9F6F0]'}`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-serif text-[#1A1A1A] mb-8">{t(`gallery.${category.key}`)}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {category.images.map((image, imgIndex) => (
                <motion.div
                  key={image}
                  initial={{ opacity: 0, scale: 0.95 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: imgIndex * 0.1 }}
                  data-testid={`gallery-image-${category.key}-${imgIndex}`}
                  className="aspect-[4/3] rounded-lg overflow-hidden cursor-pointer group"
                >
                  <img
                    src={image}
                    alt={`${category.key} ${imgIndex + 1}`}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default GalleryPage;
